export default __webpack_public_path__ + "static/media/PortaldoCliente.5c4c00f8.svg";